(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-video-loop"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  class YGAccordionVideoLoop extends YGUtils {
    constructor() {
      super();
      this.swiperInstance = null;
      this.foldingVideoObserver = null;
      this.mobileInitTimer = null;
      this.isMobileMode = false;
      this.isInitializing = true;
      this.currentActiveItem = null;
      this.showContentFrame = null;
      this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
      this.handleItemHover = this.handleItemHover.bind(this);
      this.handleVideoEnded = this.handleVideoEnded.bind(this);
    }

    get items() {
      return this.querySelectorAll('.yg-accordion-item');
    }

    connectedCallback() {
      this.currentActiveItem = this.querySelector('.yg-accordion-item.active');
      this.items.forEach((item) => {
        const video = item.querySelector('.yg-accordion-native-video');
        if (video) {
          video.muted = true;
          video.playsInline = true;
          video.addEventListener('ended', this.handleVideoEnded);
        }
      });
      this.handleResize();
      window.addEventListener('resize', this.debouncedResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.debouncedResize);
      window.clearTimeout(this.mobileInitTimer);
      this.clearTransitionTimers();
      this.destroySwiper();
      this.destroyFoldingVideoObserver();
      this.removeHoverListeners();
      this.items.forEach((item) => {
        this.controlVideo(item, 'pause');
        const video = item.querySelector('.yg-accordion-native-video');
        if (video) video.removeEventListener('ended', this.handleVideoEnded);
      });
    }

    initSwiper() {
      if (this.swiperInstance || !this.isMobileMode || !this.isConnected) return;
      if (this.classList.contains('yg-accordion-folding-card')) return;

      const galleryContainer = this.querySelector('.yg-accordion-item-container');
      const pagination = this.querySelector('.yg-accordion-pagination');
      if (!galleryContainer || !pagination || typeof Swiper === 'undefined') return;

      const itemCount = this.items.length;
      this.swiperInstance = new Swiper(galleryContainer, {
        spaceBetween: 16,
        slidesPerView: 1,
        // Image slides keep the original 3-second rotation.
        // Video slides will stop the timer so their videos can finish / loop.
        autoplay: itemCount > 1 ? { delay: 3000, disableOnInteraction: false } : false,
        autoHeight: true,
        pagination: { el: pagination, clickable: true },
        on: {
          slideChange: (swiper) => this.syncMobileSlide(swiper)
        },
        breakpoints: {
          220: { slidesPerView: 1, spaceBetween: 16 }
        }
      });
      this.syncMobileSlide(this.swiperInstance);
    }

    syncMobileSlide(swiper) {
      if (!swiper || !this.isMobileMode) return;
      this.items.forEach((item) => this.controlVideo(item, 'pause'));

      const activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;
      const activeVideo = activeSlide.querySelector('.yg-accordion-native-video');

      if (activeVideo) {
        // Do not cut off a video after 3 seconds: stop swiper autoplay.
        if (swiper.autoplay && swiper.autoplay.running) swiper.autoplay.stop();
        this.controlVideo(activeSlide, 'play');
      } else if (swiper.autoplay && swiper.slides.length > 1 && !swiper.autoplay.running) {
        swiper.autoplay.start();
      }
    }

    handleVideoEnded(event) {
      // Non-looping videos finish once; on mobile, move on to the next card.
      const video = event.currentTarget;
      if (video.loop || !this.isMobileMode || !this.swiperInstance) return;
      const currentSlide = video.closest('.yg-accordion-item');
      const swiper = this.swiperInstance;
      if (swiper.slides[swiper.activeIndex] !== currentSlide || swiper.slides.length < 2) return;
      swiper.slideTo((swiper.activeIndex + 1) % swiper.slides.length);
    }

    destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initFoldingVideoObserver() {
      this.destroyFoldingVideoObserver();
      const videoItems = Array.from(this.items).filter((item) => item.querySelector('.yg-accordion-native-video'));
      if (!videoItems.length) return;
      // In the mobile stacked-card layout, loop a video only while its card is visible.
      if (!('IntersectionObserver' in window)) return;
      this.foldingVideoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!this.isMobileMode || !this.classList.contains('yg-accordion-folding-card')) return;
          this.controlVideo(entry.target, entry.intersectionRatio >= 0.45 ? 'play' : 'pause');
        });
      }, { threshold: [0, 0.45] });
      videoItems.forEach((item) => this.foldingVideoObserver.observe(item));
    }

    destroyFoldingVideoObserver() {
      if (this.foldingVideoObserver) {
        this.foldingVideoObserver.disconnect();
        this.foldingVideoObserver = null;
      }
    }

    updateCardHeight() {
      const itemInner = this.querySelector('.yg-accordion-item-inner');
      const itemCount = this.items.length;
      if (this.isMobileMode || !itemInner || itemCount === 0) {
        this.style.removeProperty('--accordion-card-height');
        this.style.removeProperty('--accordion-active-card-width');
        return;
      }
      const gap = parseFloat(window.getComputedStyle(itemInner).columnGap) || 0;
      const availableWidth = itemInner.clientWidth - gap * (itemCount - 1);
      const activeFlex = parseFloat(window.getComputedStyle(this).getPropertyValue('--accordion-active-flex')) || 4.25;
      const inactiveCardWidth = availableWidth / (itemCount + activeFlex - 1);
      const activeCardWidth = inactiveCardWidth * activeFlex;
      const cardHeight = inactiveCardWidth * 3;
      if (cardHeight > 0 && activeCardWidth > 0) {
        this.style.setProperty('--accordion-card-height', `${cardHeight}px`);
        this.style.setProperty('--accordion-active-card-width', `${activeCardWidth}px`);
      }
    }

    handleResize() {
      const shouldBeMobile = window.innerWidth < 700;
      const modeChanged = shouldBeMobile !== this.isMobileMode;
      this.isMobileMode = shouldBeMobile;

      if (modeChanged || this.isInitializing) {
        this.clearTransitionTimers();
        window.clearTimeout(this.mobileInitTimer);
        this.items.forEach((item) => this.controlVideo(item, 'pause'));

        if (shouldBeMobile) {
          this.removeHoverListeners();
          this.clearActiveItems();
          this.mobileInitTimer = window.setTimeout(() => {
            if (!this.isConnected || !this.isMobileMode) return;
            if (this.classList.contains('yg-accordion-folding-card')) {
              this.initFoldingVideoObserver();
            } else {
              this.initSwiper();
            }
          }, 50);
        } else {
          this.destroySwiper();
          this.destroyFoldingVideoObserver();
          this.addHoverListeners();
          const activeItem = this.currentActiveItem && this.contains(this.currentActiveItem)
            ? this.currentActiveItem : this.items[0];
          this.items.forEach((item) => item.classList.remove('active', 'is-content-visible'));
          if (activeItem) {
            activeItem.classList.add('active', 'is-content-visible');
            this.currentActiveItem = activeItem;
            this.controlVideo(activeItem, 'play');
          }
        }
      }

      if (shouldBeMobile) {
        this.style.removeProperty('--accordion-card-height');
        this.style.removeProperty('--accordion-active-card-width');
      } else {
        window.requestAnimationFrame(() => this.updateCardHeight());
      }
      this.isInitializing = false;
    }

    addHoverListeners() {
      this.items.forEach((item) => {
        item.removeEventListener('mouseenter', this.handleItemHover);
        item.addEventListener('mouseenter', this.handleItemHover);
      });
    }

    removeHoverListeners() {
      this.items.forEach((item) => {
        item.removeEventListener('mouseenter', this.handleItemHover);
      });
    }

    clearActiveItems() {
      this.items.forEach((item) => item.classList.remove('active', 'is-content-visible'));
      this.currentActiveItem = null;
    }

    clearTransitionTimers() {
      if (this.showContentFrame !== null) {
        window.cancelAnimationFrame(this.showContentFrame);
      }
      this.showContentFrame = null;
    }

    activateItem(target) {
      if (target === this.currentActiveItem && target.classList.contains('active')) return;
      this.clearTransitionTimers();
      this.currentActiveItem = target;
      this.items.forEach((item) => {
        this.controlVideo(item, 'pause');
        item.classList.remove('active', 'is-content-visible');
      });
      target.classList.add('active');
      this.controlVideo(target, 'play');
      this.showContentFrame = window.requestAnimationFrame(() => {
        if (this.currentActiveItem === target && target.classList.contains('active')) {
          target.classList.add('is-content-visible');
        }
        this.showContentFrame = null;
      });
    }

    controlVideo(item, action) {
      if (!item) return;
      const video = item.querySelector('.yg-accordion-native-video');
      if (!video) return;
      if (action === 'pause') {
        video.pause();
      } else if (action === 'play') {
        video.muted = true;
        video.playsInline = true;
        const playPromise = video.play();
        // Browsers can decline autoplay (for example in Low Power Mode).
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }
    }

    handleItemHover(event) {
      this.activateItem(event.currentTarget);
    }
  }

  if (!window.customElements.get('yg-accordion-video-loop')) {
    window.customElements.define('yg-accordion-video-loop', YGAccordionVideoLoop);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  class YGAccordionVideo01 extends YGUtils {
    constructor() {
      super();
      this.swiperInstance = null;
      this.isMobileMode = false;
      this.isInitializing = true; // 标记正在初始化
      this.handleResize = this.handleResize.bind(this);
      this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
      this.handleItemHover = this.handleItemHover.bind(this);
      this.currentActiveItem = null;
      this.showContentFrame = null;
    }

    get items() {
      return this.querySelectorAll('.yg-accordion-item');
    }

    connectedCallback() {
      // 初始化时根据当前屏幕尺寸设置正确的模式和监听器
      this.currentActiveItem = this.querySelector('.yg-accordion-item.active');
      this.handleResize();
      window.addEventListener('resize', this.debouncedResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.debouncedResize);
      this.clearTransitionTimers();
      this.destroySwiper();
      this.removeHoverListeners();
    }

    initSwiper() {
      if (this.swiperInstance) return;

      // 如果是 folding card 模式且在移动端，不初始化轮播
      if (this.classList.contains('yg-accordion-folding-card') && this.isMobileMode) {
        return;
      }

      const galleryContainer = this.querySelector('.yg-accordion-item-container');
      const pagination = this.querySelector('.yg-accordion-pagination');
      if (!galleryContainer || !pagination) return;

      this.swiperInstance = new Swiper(galleryContainer, {
        spaceBetween: 16,
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        autoHeight: true,
        pagination: {
          el: pagination,
          clickable: true,
        },
        on: {
          slideChange: () => {
            // 暂停所有视频
            this.items.forEach((item) => {
              this.controlVideo(item, 'pause');
            });
            // 播放当前活动的slide的视频
            const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
            if (activeSlide) {
              this.controlVideo(activeSlide, 'play');
            }
          }
        },
        breakpoints: {
          220: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
        },
      });

      // 初始化时播放第一个活动的slide的视频
      setTimeout(() => {
        const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
        if (activeSlide) {
          this.controlVideo(activeSlide, 'play');
        }
      }, 100);
    }

    destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    updateCardHeight() {
      const itemInner = this.querySelector('.yg-accordion-item-inner');
      const itemCount = this.items.length;

      if (this.isMobileMode || !itemInner || itemCount === 0) {
        this.style.removeProperty('--accordion-card-height');
        this.style.removeProperty('--accordion-active-card-width');
        return;
      }

      const gap = parseFloat(window.getComputedStyle(itemInner).columnGap) || 0;
      const availableWidth = itemInner.clientWidth - gap * (itemCount - 1);
      const activeFlex = parseFloat(window.getComputedStyle(this).getPropertyValue('--accordion-active-flex')) || 4.25;
      const inactiveCardWidth = availableWidth / (itemCount + activeFlex - 1);
      const activeCardWidth = inactiveCardWidth * activeFlex;
      const cardHeight = inactiveCardWidth * 3;

      if (cardHeight > 0 && activeCardWidth > 0) {
        this.style.setProperty('--accordion-card-height', `${cardHeight}px`);
        this.style.setProperty('--accordion-active-card-width', `${activeCardWidth}px`);
      }
    }

    handleResize() {
      const width = window.innerWidth;
      const shouldBeMobile = width < 700;
      const modeChanged = shouldBeMobile !== this.isMobileMode;

      // 更新当前模式
      this.isMobileMode = shouldBeMobile;

      if (modeChanged || this.isInitializing) {
        this.clearTransitionTimers();

        if (shouldBeMobile) {
          // 切换到移动端模式
          this.removeHoverListeners();
          this.clearActiveItems();
          // 延迟初始化轮播，确保DOM已准备好
          setTimeout(() => this.initSwiper(), 50);
        } else {
          // 切换到PC端模式
          this.destroySwiper();
          this.addHoverListeners();
          // 重新激活上次选中的项目；没有记录时使用第一项
          const activeItem = this.currentActiveItem || this.items[0];
          if (activeItem) {
            activeItem.classList.add('active', 'is-content-visible');
            this.currentActiveItem = activeItem;
            this.controlVideo(activeItem, 'play');
          }
        }
      }

      if (shouldBeMobile) {
        this.style.removeProperty('--accordion-card-height');
        this.style.removeProperty('--accordion-active-card-width');
      } else {
        window.requestAnimationFrame(() => this.updateCardHeight());
      }

      // 标记初始化完成
      this.isInitializing = false;
    }

    addHoverListeners() {
      this.items.forEach((item) => {
        item.removeEventListener('mouseenter', this.handleItemHover);
        item.addEventListener('mouseenter', this.handleItemHover);
      });
    }

    removeHoverListeners() {
      this.items.forEach((item) => {
        item.removeEventListener('mouseenter', this.handleItemHover);
      });
    }

    clearActiveItems() {
      this.items.forEach((item) => item.classList.remove('active', 'is-content-visible'));
      this.currentActiveItem = null;
    }

    clearTransitionTimers() {
      window.cancelAnimationFrame(this.showContentFrame);
      this.showContentFrame = null;
    }

    activateItem(target) {
      if (target === this.currentActiveItem && target.classList.contains('active')) {
        return;
      }

      if (target.classList.contains('active')) {
        this.clearTransitionTimers();
        this.currentActiveItem = target;
        target.classList.add('is-content-visible');
        this.controlVideo(target, 'play');
        return;
      }

      this.clearTransitionTimers();

      this.currentActiveItem = target;

      this.items.forEach((item) => this.controlVideo(item, 'pause'));
      this.items.forEach((item) => item.classList.remove('active', 'is-content-visible'));
      target.classList.add('active');
      this.controlVideo(target, 'play');

      this.showContentFrame = window.requestAnimationFrame(() => {
        if (this.currentActiveItem === target && target.classList.contains('active')) {
          target.classList.add('is-content-visible');
        }
        this.showContentFrame = null;
      });
    }

    controlVideo(item, action) {
      const videoElement = item.querySelector('yg-video');
      if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
        // 检查是否有实际的视频内容
        const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
        if (hasVideoContent || videoElement.template) {
          if (action === 'play') {
            videoElement.playVideo();
          } else if (action === 'pause') {
            videoElement.pauseVideo();
          }
        }
      }
    }

    handleItemHover(e) {
      this.activateItem(e.currentTarget);
    }
  }

  if (!window.customElements.get('yg-accordion-video-01')) {
    window.customElements.define('yg-accordion-video-01', YGAccordionVideo01);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!window.customElements.get('yg-footer-back-to-top')) {
    class YGFooterBackToTop extends HTMLElement {
      constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.$button = this.querySelector('button');

        if (!this.$button) {
          return;
        }

        this.$button.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        if (!this.$button) {
          return;
        }

        this.$button.removeEventListener('click', this.handleClick);
      }

      handleClick() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }

    window.customElements.define('yg-footer-back-to-top', YGFooterBackToTop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-avatar-experience"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vinabot-avatar-experience')){
customElements.define('vinabot-avatar-experience',class extends HTMLElement{
 connectedCallback(){if(this._abort||this._initTimer)return;this._initTimer=setTimeout(()=>{this._initTimer=null;if(this.isConnected)this.initialize()},0)}
 initialize(){if(this._abort)return;this._abort=new AbortController();const signal=this._abort.signal;this.tabs=[...this.querySelectorAll('[data-va-tab]')];this.scenes=[...this.querySelectorAll('[data-va-scene]')];if(!this.tabs.length||this.tabs.length!==this.scenes.length){this._abort=null;return}this.sequence=0;
  this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.activate(index),{signal});tab.addEventListener('keydown',event=>{let target;if(event.key==='ArrowRight')target=(index+1)%this.tabs.length;else if(event.key==='ArrowLeft')target=(index+this.tabs.length-1)%this.tabs.length;else if(event.key==='Home')target=0;else if(event.key==='End')target=this.tabs.length-1;else return;event.preventDefault();this.activate(target);this.tabs[target].focus({preventScroll:true})},{signal})});
  this.scenes.forEach((scene,index)=>{scene.querySelector('[data-va-number]').textContent=String(index+1).padStart(2,'0');scene.querySelectorAll('[data-va-question]').forEach(button=>button.addEventListener('click',()=>this.choose(button),{signal}));scene.querySelector('[data-va-play]').addEventListener('click',()=>this.toggle(),{signal})});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)this.pause()},{signal});document.addEventListener('vinabot:reply-video-play',event=>{if(event.detail?.owner!==this)this.pause()},{signal});document.addEventListener('shopify:block:select',event=>{if(!this.contains(event.target))return;const scene=event.target.closest('[data-va-scene]')||event.target.querySelector('[data-va-scene]');const index=this.scenes.indexOf(scene);if(index>=0)this.activate(index)},{signal});
  this.setAttribute('data-ready','');this.activate(0,false);
 }
 activate(index,scroll=true){if(index<0||index>=this.scenes.length)return;this.release();this.index=index;this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(index===i));tab.tabIndex=index===i?0:-1;(this.scenes[i].closest('.va-scene-block')||this.scenes[i]).hidden=index!==i});this.scene=this.scenes[index];this.choose(this.scene.querySelector('[data-va-question][aria-pressed=true]')||this.scene.querySelector('[data-va-question]'));if(scroll){const row=this.querySelector('.va-tabs'),tab=this.tabs[index];const left=tab.offsetLeft-row.offsetLeft-(row.clientWidth-tab.offsetWidth)/2;row.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}}
 choose(button){this.release();this.choice=button;this.scene.querySelectorAll('[data-va-question]').forEach(q=>q.setAttribute('aria-pressed',String(q===button)));this.scene.querySelector('[data-va-answer]').textContent=this.scene.querySelector('[data-va-answer-template='+button.dataset.vaQuestion+']').content.textContent.trim();this.setState(button.dataset.url?'ready':'missing')}
 setState(state){clearTimeout(this.timer);this.state=state;const button=this.scene?.querySelector('[data-va-play]'),status=this.scene?.querySelector('[data-va-status]');if(!button)return;const active=['playing','loading','buffering'].includes(state);button.disabled=state==='missing';button.setAttribute('aria-pressed',String(active));button.textContent=state==='missing'?this.dataset.missing:active?this.dataset.pause:state==='paused'?this.dataset.resume:state==='ended'?this.dataset.replay:state==='error'?this.dataset.retry:this.dataset.play;status.textContent=['loading','buffering'].includes(state)?this.dataset.loading:state==='error'?this.dataset.error:'';if(['loading','buffering'].includes(state)){const version=this.sequence;this.timer=setTimeout(()=>{if(this.isConnected&&this.sequence===version&&['loading','buffering'].includes(this.state))this.fail(false)},15000)}}
 mount(){const url=this.choice?.dataset.url;if(!url)return null;const video=this.scene.querySelector('[data-va-video]');this.video=video;this._media=new AbortController();const signal=this._media.signal,current=()=>this.video===video&&this.isConnected;
  video.hidden=true;video.controls=false;video.autoplay=false;video.loop=false;video.muted=false;video.defaultMuted=false;video.playsInline=true;video.preload='metadata';video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');video.removeAttribute('muted');video.removeAttribute('autoplay');video.src=url;const portrait=this.scene.querySelector('.va-portrait img');if(portrait)video.poster=portrait.currentSrc||portrait.src;else video.removeAttribute('poster');video.setAttribute('aria-label',this.choice.textContent.trim());
  video.addEventListener('playing',()=>{if(!current())return;video.controls=false;video.hidden=false;this.setState('playing');document.querySelectorAll('audio,video').forEach(other=>{if(other!==video)other.pause()})},{signal});video.addEventListener('pause',()=>{if(current()&&!video.ended&&this.state!=='error')this.setState('paused')},{signal});video.addEventListener('waiting',()=>{if(current()&&!video.paused)this.setState('buffering')},{signal});video.addEventListener('ended',()=>{if(current()){video.hidden=true;video.controls=false;this.setState('ended')}},{signal});video.addEventListener('error',()=>{if(current())this.fail(false)},{signal});video.load();return video;
 }
 toggle(){if(this.state==='missing')return;if(['playing','loading','buffering'].includes(this.state)){this.pause();return}if(this.state==='error')this.release();const video=this.video||this.mount();if(!video){this.setState('missing');return}if(this.state==='ended'||video.ended){try{video.currentTime=0}catch{}}video.controls=false;const version=++this.sequence;this.setState('loading');document.dispatchEvent(new CustomEvent('vinabot:reply-video-play',{detail:{owner:this}}));let promise;try{promise=video.play()}catch(error){this.fail(error.name==='NotAllowedError');return}Promise.resolve(promise).catch(error=>{if(this.isConnected&&this.video===video&&this.sequence===version&&this.state!=='paused')this.fail(error.name==='NotAllowedError')})}
 fail(nativeFallback){clearTimeout(this.timer);this.sequence++;this.setState('error');if(this.video){this.video.pause();this.video.hidden=!nativeFallback;this.video.controls=nativeFallback}}
 pause(){if(this.video&&['playing','loading','buffering'].includes(this.state)){this.sequence++;this.video.pause();this.setState('paused')}}
 release(){clearTimeout(this.timer);this.sequence=(this.sequence||0)+1;this._media?.abort();this._media=null;if(this.video){this.video.pause();this.video.hidden=true;this.video.controls=false;this.video.removeAttribute('src');this.video.removeAttribute('poster');this.video.load()}this.video=null}
 disconnectedCallback(){clearTimeout(this._initTimer);this._initTimer=null;this.release();this._abort?.abort();this._abort=null}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-home-real-life"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vinabot-real-life')){
customElements.define('vinabot-real-life',class extends HTMLElement{
 connectedCallback(){clearTimeout(this._initTimer);this._initTimer=setTimeout(()=>{if(this.isConnected)this.initialize()},0)}
 initialize(){
  if(this._abort)return;this._abort=new AbortController();const signal=this._abort.signal;this.track=this.querySelector('.vr-track');if(!this.track){this._abort=null;return}
  this.dialog=this.querySelector('dialog');this.video=this.querySelector('[data-vr-player]');this.status=this.querySelector('.vr-status');this.active='all';this.positions=new Map();this.filters=[...this.querySelectorAll('[data-filter]')];this.arrows=[...this.querySelectorAll('[data-direction]')];
  this.refresh();
  this.filters.forEach(button=>button.addEventListener('click',()=>{if(this.active===button.dataset.filter)return;this.positions.set(this.active,this.track.scrollLeft);this.active=button.dataset.filter;this.refresh();this.track.scrollLeft=this.positions.get(this.active)||0;this.updateArrows()},{signal}));
  this.arrows.forEach(button=>button.addEventListener('click',()=>{const direction=Number(button.dataset.direction);this.track.scrollBy({left:direction*this.track.clientWidth*.78,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})},{signal}));
  this.track.addEventListener('scroll',()=>this.updateArrows(),{signal,passive:true});
  this.track.addEventListener('keydown',event=>{if(event.target!==this.track)return;if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;event.preventDefault();this.track.scrollBy({left:(event.key==='ArrowLeft'?-1:1)*this.track.clientWidth*.78,behavior:'auto'})},{signal});
  this.track.addEventListener('click',event=>{const button=event.target.closest('[data-vr-play]');if(!button)return;this.opener=button;this.querySelector('.vr-modal h3').textContent=button.dataset.title;this.video.pause();this.video.removeAttribute('poster');if(button.dataset.poster)this.video.poster=button.dataset.poster;this.video.src=button.dataset.src;this.status.textContent=this.status.dataset.loading;this.dialog.showModal();this.video.load();const playing=this.video.play();playing?.catch(()=>{if(!this.video.error)this.status.textContent=''})},{signal});
  this.querySelector('.vr-close').addEventListener('click',()=>this.dialog.close(),{signal});
  this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close()},{signal});
  this.dialog.addEventListener('close',()=>{this.video.pause();this.video.removeAttribute('src');this.video.removeAttribute('poster');this.video.load();this.status.textContent='';if(this.opener?.isConnected)this.opener.focus({preventScroll:true})},{signal});
  this.video.addEventListener('play',()=>document.querySelectorAll('audio,video').forEach(other=>{if(other!==this.video)other.pause()}),{signal});
  this.video.addEventListener('loadeddata',()=>this.status.textContent='',{signal});this.video.addEventListener('playing',()=>this.status.textContent='',{signal});this.video.addEventListener('waiting',()=>{if(this.dialog.open)this.status.textContent=this.status.dataset.loading},{signal});this.video.addEventListener('error',()=>{if(this.dialog.open&&this.video.hasAttribute('src'))this.status.textContent=this.status.dataset.error},{signal});
  document.addEventListener('shopify:block:select',event=>{if(!this.contains(event.target))return;const item=event.target.matches('[data-vr-item]')?event.target:event.target.querySelector('[data-vr-item]');if(!item)return;const wrapper=item.closest('.vr-card')||item;if(wrapper.hidden){this.active=item.dataset.category==='all_only'?'all':item.dataset.category;this.refresh()}const r=wrapper.getBoundingClientRect(),t=this.track.getBoundingClientRect();this.track.scrollLeft+=r.left-t.left;this.updateArrows()},{signal});
  this._resize=new ResizeObserver(()=>{const width=this.track.clientWidth;if(width!==this._width){this._width=width;this.refresh()}else this.updateArrows()});this._resize.observe(this.track);this._mutation=new MutationObserver(()=>this.refresh());this._mutation.observe(this.track,{childList:true,subtree:true});
 }
 refresh(){this.items=[...this.track.querySelectorAll('[data-vr-item]')];const previous=this.track.scrollLeft;this.track.style.removeProperty('--vr-track-height');this.items.forEach(item=>(item.closest('.vr-card')||item).hidden=false);const height=this.track.getBoundingClientRect().height;this.track.style.setProperty('--vr-track-height',Math.ceil(height)+'px');let count=0;this.items.forEach(item=>{const wrapper=item.closest('.vr-card')||item;const visible=this.active==='all'?item.dataset.inAll!=='false':item.dataset.category===this.active;wrapper.hidden=!visible;if(visible)count++});this.filters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===this.active)));this.querySelector('.vr-empty').hidden=count!==0;const counter=this.querySelector('[data-vr-count]');if(counter)counter.textContent=count;this.track.scrollLeft=previous;this.updateArrows()}
 updateArrows(){if(!this.track||this.arrows.length<2)return;const overflow=this.track.scrollWidth>this.track.clientWidth+2;this.querySelector('.vr-arrows').hidden=!overflow;this.arrows[0].disabled=this.track.scrollLeft<=2;this.arrows[1].disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2}
 disconnectedCallback(){clearTimeout(this._initTimer);this._mutation?.disconnect();this._resize?.disconnect();if(this.dialog?.open)this.dialog.close();if(this.video){this.video.pause();this.video.removeAttribute('src');this.video.load()}this._abort?.abort();this._abort=null}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-story-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vinabot-story-carousel')){
customElements.define('vinabot-story-carousel',class extends HTMLElement{
 connectedCallback(){this.timer=setTimeout(()=>this.init(),0)}
 init(){
  this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
  this.track=this.querySelector('[data-sc-track]');if(!this.track)return;
  this.controls=this.querySelector('[data-sc-controls]');this.pagination=this.querySelector('[data-sc-pagination]');this.pages=this.querySelector('[data-sc-pages]');this.prev=this.querySelector('[data-sc-prev]');this.next=this.querySelector('[data-sc-next]');this.status=this.querySelector('[data-sc-status]');
  this.prev.addEventListener('click',()=>this.go(this.index-1,true),{signal});
  this.next.addEventListener('click',()=>this.go(this.index+1,true),{signal});
  this.addEventListener('keydown',e=>{
   if(e.target.closest('video,audio,input,textarea,select'))return;
   if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1),true)}
  },{signal});
  this.track.addEventListener('touchstart',e=>{
   this.touch=null;if(e.target.closest('video,a,button,input'))return;
   if(e.touches.length===1)this.touch={x:e.touches[0].clientX,y:e.touches[0].clientY};
  },{signal,passive:true});
  this.track.addEventListener('touchend',e=>{
   if(!this.touch||!e.changedTouches.length)return;
   const dx=e.changedTouches[0].clientX-this.touch.x,dy=e.changedTouches[0].clientY-this.touch.y;this.touch=null;
   if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.3)this.go(this.index+(dx<0?1:-1),true);
  },{signal,passive:true});
  this.track.addEventListener('touchcancel',()=>{this.touch=null},{signal,passive:true});
  this.track.addEventListener('click',e=>{
   const button=e.target.closest('[data-video-toggle]');if(!button)return;const video=button.parentElement.querySelector('video');if(!video)return;
   if(video.paused)video.play().catch(()=>{});else video.pause();
  },{signal});
  document.addEventListener('shopify:block:select',e=>{
   const i=this.slides.findIndex(slide=>slide.dataset.blockId===e.detail?.blockId);
   if(i>=0)this.go(i,false);
  },{signal});
  this.refresh();
  this.observer?.disconnect();this.observer=new MutationObserver(()=>this.refresh());
  this.observer.observe(this.track,{childList:true});
 }
 refresh(){
  const old=this.slides?.[this.index]?.dataset.blockId,previous=this.index||0;
  this.slides=[...this.track.children].filter(el=>el.matches('[data-sc-slide]'));
  this.pages.replaceChildren();
  this.slides.forEach((slide,i)=>{
   slide.setAttribute('aria-roledescription',this.dataset.slideLabel);
   const button=document.createElement('button');button.type='button';button.className='vsc-page';button.textContent=String(i+1).padStart(2,'0');
   button.setAttribute('aria-label',this.dataset.goLabel+' '+(i+1));button.setAttribute('aria-controls',slide.id);
   button.addEventListener('click',()=>this.go(i,true));this.pages.append(button);
  });
  this.index=Math.max(0,this.slides.findIndex(slide=>slide.dataset.blockId===old));
  if(!old)this.index=Math.min(previous,Math.max(this.slides.length-1,0));
  this.track.dataset.ready='true';this.hidden=this.slides.length===0;this.controls.hidden=this.slides.length<2;this.pagination.hidden=this.slides.length<2;
  this.track.querySelectorAll('video').forEach(video=>{
   if(this.boundVideos?.has(video))return;
   if(!this.boundVideos)this.boundVideos=new WeakSet();this.boundVideos.add(video);
   const update=()=>{const button=video.parentElement.querySelector('[data-video-toggle]');if(button)button.setAttribute('aria-pressed',String(!video.paused))};
   video.addEventListener('play',()=>{this.track.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause()});update()},{signal:this.abort.signal});
   video.addEventListener('pause',update,{signal:this.abort.signal});video.addEventListener('ended',update,{signal:this.abort.signal});
  });
  this.go(this.index,false);
 }
 go(index,announce){
  const count=this.slides.length;if(!count)return;
  index=this.dataset.loop==='true'?(index+count)%count:Math.max(0,Math.min(index,count-1));
  const focused=document.activeElement,old=this.slides[this.index];
  if(old&&old!==this.slides[index]&&old.contains(focused))this.next.focus();
  this.index=index;
  this.slides.forEach((slide,i)=>{
   slide.hidden=i!==index;slide.setAttribute('aria-hidden',String(i!==index));
   if(i!==index)slide.querySelectorAll('video').forEach(video=>video.pause());
  });
  [...this.pages.children].forEach((button,i)=>{if(i===index)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current')});
  const current=this.pages.children[index];
  if(current){const item=current.getBoundingClientRect(),rail=this.pages.getBoundingClientRect();if(item.left<rail.left)this.pages.scrollLeft+=item.left-rail.left;else if(item.right>rail.right)this.pages.scrollLeft+=item.right-rail.right}
  this.prev.disabled=this.dataset.loop!=='true'&&index===0;this.next.disabled=this.dataset.loop!=='true'&&index===count-1;
  if(announce)this.status.textContent=(index+1)+' / '+count;
 }
 disconnectedCallback(){
  clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();
  this.querySelectorAll('video').forEach(video=>video.pause());this.boundVideos=null;
 }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-accordion-01"] && !Shopify.designMode) return;
  try {
    
class YGAccordion01 extends HTMLElement {
  #sectionEl;

  constructor() {
    super();
    this.currentStepIndex = 0;
    this.mobileSwiper = null;
    this.isVisible = false;
    this.observer = null;

    this.handleDropdownOpen = this.handleDropdownOpen.bind(this);
    this.handleProgressEnd = this.handleProgressEnd.bind(this);
    this.handleMobileSlideChange = this.handleMobileSlideChange.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  get sectionElements() {
    if (this.#sectionEl) return this.#sectionEl;
    this.#sectionEl = {
      accordionList: this.querySelectorAll('.yg-process-steps-item'),
      progressBars: this.querySelectorAll('.yg-process-steps-progress-bar'),
      desktopControls: this.querySelectorAll('.yg-process-steps-media'),
      mobileControls: this.querySelectorAll('.yg-process-steps-content-media'),
      mobileSwiperElement: this.querySelector('.yg-accordion-mobile-swiper'),
      mobileSwiperSlides: this.querySelectorAll('.yg-accordion-mobile-slide')
    };

    return this.#sectionEl;
  }

  get isMobileSwiperMode() {
    return window.innerWidth <= 699 && this.dataset.mobileSwiperEnabled === 'true';
  }

  connectedCallback() {
    document.addEventListener('YG:dropdown-open', this.handleDropdownOpen);
    document.addEventListener('YG:progress-end', this.handleProgressEnd);
    window.addEventListener('resize', this.handleResize);

    this.initIntersectionObserver();
    this.bindMobileSwiper();
  }

  disconnectedCallback() {
    document.removeEventListener('YG:dropdown-open', this.handleDropdownOpen);
    document.removeEventListener('YG:progress-end', this.handleProgressEnd);
    window.removeEventListener('resize', this.handleResize);

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.unbindMobileSwiper();
    this.pauseAllVideos();
  }

  initIntersectionObserver() {
    this.observer = new IntersectionObserver(this.handleIntersection, {
      threshold: 0.2 // 可根据需要调整阈值，20% 可见即视为进入视口
    });
    this.observer.observe(this);
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      this.isVisible = entry.isIntersecting;

      if (this.isVisible) {
        this.resumePlayback();
      } else {
        this.pausePlayback();
      }
    });
  }

  resumePlayback() {
    if (this.isMobileSwiperMode) {
      this.playMobileSwiperVideo();
      return;
    }

    const currentItem = this.sectionElements.accordionList[this.currentStepIndex];
    const currentId = currentItem?.getAttribute('data-id');

    if (currentId) {
      this.startProgressForId(currentId);
      this.playVideo(currentId);
    }
  }

  pausePlayback() {
    this.stopAllProgress();
    this.pauseAllVideos();
  }

  stopAllProgress() {
    this.sectionElements.progressBars?.forEach((item) => {
      item.stopProgress?.();
    });
  }

  bindMobileSwiper(retryCount = 12) {
    if (this.dataset.mobileSwiperEnabled !== 'true') {
      return;
    }

    const swiper = this.sectionElements.mobileSwiperElement?.swiper;

    if (!swiper) {
      if (retryCount > 0) {
        window.setTimeout(() => this.bindMobileSwiper(retryCount - 1), 120);
      }
      return;
    }

    if (this.mobileSwiper === swiper) {
      return;
    }

    this.unbindMobileSwiper();
    this.mobileSwiper = swiper;
    this.mobileSwiper.on('slideChange', this.handleMobileSlideChange);
    
    if (this.isVisible) {
      this.handleMobileSlideChange();
    }
  }

  unbindMobileSwiper() {
    if (this.mobileSwiper?.off) {
      this.mobileSwiper.off('slideChange', this.handleMobileSlideChange);
    }

    this.mobileSwiper = null;
  }

  handleDropdownOpen(event) {
    const id = event.detail?.id;

    if (this.isMobileSwiperMode || !id) {
      return;
    }

    this.currentStep(id);
  }

  handleProgressEnd(event) {
    const id = event.detail?.id;

    // 不在视口中或移动端 Swiper 模式下，直接忽略跳步事件
    if (!this.isVisible || this.isMobileSwiperMode || !id) {
      return;
    }

    this.nextStep(id);
  }

  handleMobileSlideChange() {
    if (!this.isMobileSwiperMode || !this.mobileSwiper) {
      return;
    }

    this.currentStepIndex = typeof this.mobileSwiper.realIndex === 'number'
      ? this.mobileSwiper.realIndex
      : this.mobileSwiper.activeIndex;

    if (this.isVisible) {
      this.playMobileSwiperVideo(this.currentStepIndex);
    }
  }

  handleResize() {
    if (this.isMobileSwiperMode) {
      this.bindMobileSwiper();
      this.pauseAccordionVideos();
      if (this.isVisible) {
        this.playMobileSwiperVideo();
      }
      return;
    }

    this.pauseMobileSwiperVideos();
    if (this.isVisible) {
      const currentId = this.sectionElements.accordionList[this.currentStepIndex]?.getAttribute('data-id');
      if (currentId) {
        this.startProgressForId(currentId);
        this.playVideo(currentId);
      }
    }
  }

  nextStep(id) {
    this.sectionElements.accordionList.forEach((item, i) => {
      if (item.getAttribute('data-id') === id) {
        let indexNext = i === this.sectionElements.accordionList.length - 1 ? 0 : i + 1;
        this.currentStepIndex = indexNext;
      }
    });

    if (!this.isCurrentStep(id)) {
      return;
    }
    this.sectionElements.accordionList[this.currentStepIndex]?.openDropdown();
  }

  currentStep(id) {
    if (!this.isCurrentStep(id)) {
      return;
    }
    this.setActiveControl(id);

    // 只有在视口中才启动进度与视频播放
    if (this.isVisible) {
      this.startProgressForId(id);
      this.playVideo(id);
    }
  }

  isCurrentStep(id) {
    let isCurrentStep = false;
    this.sectionElements.accordionList.forEach((item) => {
      if (item.getAttribute('data-id') === id) {
        isCurrentStep = true;
      }
    });
    return isCurrentStep;
  }

  getEffectiveId(id) {
    let isMobile = window.innerWidth <= 699;
    if (isMobile) {
      return id.replace('steps-item-', 'steps-item-mobile-');
    }
    return id;
  }

  setActiveControl(id) {
    const controlGroups = [...this.sectionElements.desktopControls, ...this.sectionElements.mobileControls];

    controlGroups.forEach((item) => {
      if (item.getAttribute('data-id') === id) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
  }

  startProgressForId(id) {
    this.sectionElements.progressBars?.forEach((item, i) => {
      if (item.getAttribute('data-id') === id) {
        this.currentStepIndex = i;
        item.startProgress();
      } else {
        item.stopProgress();
      }
    });
  }

  getVideoById(id) {
    let videoEl = null;
    const controlGroups = [...this.sectionElements.desktopControls, ...this.sectionElements.mobileControls];

    controlGroups.forEach((item) => {
      if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
        videoEl = item.querySelector('yg-video');
      }
    });
    return videoEl;
  }

  pauseAccordionVideos() {
    const controlGroups = [...this.sectionElements.desktopControls, ...this.sectionElements.mobileControls];

    controlGroups.forEach((item) => {
      const videoEl = item.querySelector('yg-video');
      if (videoEl && typeof videoEl.pauseVideo === 'function') {
        videoEl.pauseVideo();
      }
    });
  }

  pauseMobileSwiperVideos() {
    this.sectionElements.mobileSwiperSlides.forEach((slide) => {
      const videoEl = slide.querySelector('yg-video');
      if (videoEl && typeof videoEl.pauseVideo === 'function') {
        videoEl.pauseVideo();
      }
    });
  }

  pauseAllVideos() {
    this.pauseAccordionVideos();
    this.pauseMobileSwiperVideos();
  }

  playVideo(id) {
    let effectiveId = this.getEffectiveId(id);
    this.pauseAccordionVideos();
    const videoEl = this.getVideoById(effectiveId);
    if (videoEl && typeof videoEl.playVideo === 'function') {
      videoEl.playVideo();
    }
  }

  playMobileSwiperVideo(index) {
    if (!this.isMobileSwiperMode) {
      return;
    }

    const activeIndex = typeof index === 'number'
      ? index
      : typeof this.mobileSwiper?.realIndex === 'number'
        ? this.mobileSwiper.realIndex
        : this.mobileSwiper?.activeIndex || 0;

    this.pauseMobileSwiperVideos();

    const videoEl = this.sectionElements.mobileSwiperSlides[activeIndex]?.querySelector('yg-video');
    if (videoEl && typeof videoEl.playVideo === 'function') {
      videoEl.playVideo();
    }
  }
}

if (!window.customElements.get('yg-accordion-01')) {
  window.customElements.define('yg-accordion-01', YGAccordion01);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-faq-with-tab"] && !Shopify.designMode) return;
  try {
    
  class YGFAQTabs extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-yg-faq-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-yg-faq-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
      });
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
      });
    }

    handleTabClick(event) {
      const selectedTab = event.currentTarget;
      const selectedPanelId = selectedTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', tab === selectedTab ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== selectedPanelId;
      });
    }
  }

  if (!window.customElements.get('yg-faq-tabs')) {
    window.customElements.define('yg-faq-tabs', YGFAQTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // 让 Vue 忽略以 yg- 开头的自定义标签（如 yg-image、yg-select 等），避免 Unknown custom element 报错
    if (window.Vue && Vue.config) {
      Vue.config.ignoredElements = Vue.config.ignoredElements || [];
      Vue.config.ignoredElements.push(/^yg-/);
    }

    class YGProductCompare extends HTMLElement {
      constructor() {
        super();
      }
      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;
        this._sectionsEl = {
          'add-to-cart': this.querySelectorAll('.yg-product-button-add-to-cart'),
          'learn-more': this.querySelector('.yg-learn-more-button'),
          'product-form': this.querySelector('#yg-product-form') || this.querySelector('.yg-product-form'),
          'product-form-id': this.querySelector('#yg-product-form-id') || this.querySelector('.yg-product-form-id'),
          'product-data': this.querySelector('.yg-product-data'),
        };

        return this._sectionsEl;
      }
      connectedCallback() {
        this.initVue();
        this.initStyle();

        // 事件委托：避免 Vue patch/re-render 后按钮节点被替换导致监听丢失
        this.addEventListener('click', (event) => {
          const addBtn =
            event.target && event.target.closest ? event.target.closest('.yg-product-button-add-to-cart') : null;
          if (addBtn && this.contains(addBtn)) {
            event.preventDefault?.();
            this.handleAddToCart(addBtn);
            return;
          }

          const learnMoreBtn =
            event.target && event.target.closest ? event.target.closest('.yg-learn-more-button') : null;
          if (learnMoreBtn && this.contains(learnMoreBtn)) {
            event.preventDefault?.();
            this.handleLearnMore(learnMoreBtn);
          }
        });
      }
      initVue() {
        if (!window.Vue || !window.ELEMENT) {
          console.warn('[yg-product-compare] Vue or Element UI is not available.');
          return;
        }

        let _this = this;
        new Vue({
          el: _this.querySelector('.yg-select-vue'),
          delimiters: ['${', '}'], // 自定义插值语法，防止与 Liquid 冲突
          data() {
            // 从 textarea#compare-data 中读取初始配置（options / values）
            let initialState = {
              options: [],
              values: [],
              // 每列当前选中的变体信息（会在初始化和商品切换/变体切换时同步更新）
              // [{ id, price, compare_at_price, available }]
              variantsCurrent: [
                { id: null, price: null, compare_at_price: null, featured_image: null, available: null },
                { id: null, price: null, compare_at_price: null, featured_image: null, available: null },
                { id: null, price: null, compare_at_price: null, featured_image: null, available: null },
              ],
            };

            const textarea = _this.querySelector('#compare-data');
            if (textarea) {
              const raw = (textarea.value || textarea.textContent || '').trim();
              if (raw) {
                let parsed;
                try {
                  // 优先按 JSON 解析
                  parsed = JSON.parse(raw);
                } catch (e) {
                  // textarea 内目前是 JS 对象字面量格式，退回用 Function 解析
                  parsed = new Function('return ' + raw)();
                }
                if (parsed && Array.isArray(parsed.options)) {
                  initialState.options = parsed.options;
                }

                // 默认显示前 3 个商品
                initialState.values = initialState.options.slice(0, 3).map((opt) => opt.value);

                // 初始化每一列的变体选择和价格，默认选中第一个变体
                initialState.variantsCurrent = [];
                initialState.values.forEach((handle) => {
                  const opt = initialState.options.find((o) => o && o.value === handle);
                  const variants = opt && opt.data && Array.isArray(opt.data.variants) ? opt.data.variants : [];
                  const firstVariant = variants[0] || null;
                  initialState.variantsCurrent.push({
                    id: firstVariant ? firstVariant.id : null,
                    price: firstVariant ? firstVariant.price : null,
                    compare_at_price: firstVariant ? firstVariant.compare_at_price : null,
                    featured_image:
                      firstVariant && firstVariant.featured_image ? firstVariant.featured_image.src : null,
                    available: firstVariant ? firstVariant.available : null,
                  });
                });

                while (initialState.variantsCurrent.length < 3) {
                  initialState.variantsCurrent.push({
                    id: null,
                    price: null,
                    compare_at_price: null,
                    featured_image: null,
                    available: null,
                  });
                }
              }
            }

            return initialState;
          },
          methods: {
            // 价格格式化：读取宿主元素 data-currency-format
            formatMoney(cents) {
              const format = _this.getAttribute('data-currency-format');
              const valueNumber = Number(cents) || 0;
              const amount = valueNumber / 100;
              // 保留两位小数，可以按需调整
              const amountStr = amount.toFixed(2);
              return format + amountStr;
            },
            hasCompareAtPrice(price, compareAtPrice) {
              const priceNumber = Number(price) || 0;
              const compareAtPriceNumber = Number(compareAtPrice) || 0;
              return compareAtPriceNumber > priceNumber;
            },
            // 顶部商品下拉变化时：重置该列的变体下拉为新商品的默认（第一个）变体
            handleProductChange(columnIndex, newColumnValue) {
              const variants = (this.variantsMap && this.variantsMap[newColumnValue]) || [];
              const nextVariant = variants[0] || null;
              const nextId = nextVariant ? nextVariant.id : null;

              this.$set(this.variantsCurrent, columnIndex, {
                id: nextId,
                price: nextVariant ? nextVariant.price : null,
                compare_at_price: nextVariant ? nextVariant.compare_at_price : null,
                featured_image: nextVariant && nextVariant.featured_image ? nextVariant.featured_image.src : null,
                available: nextVariant ? nextVariant.available : null,
              });
              // 可选：复用原有日志/逻辑（保证两处行为一致）
              if (nextId != null) this.handleVariantChange(newColumnValue, nextId, columnIndex);
            },
            // 变体下拉发生变化时触发
            handleVariantChange(columnValue, variantId, columnIndex) {
              const variants = (this.variantsMap && this.variantsMap[columnValue]) || [];
              // 这里用字符串比较，避免 id 一个是数字一个是字符串导致匹配不到
              const selected = variants.find((v) => v && String(v.id) === String(variantId)) || null;
              const label = selected ? selected.public_title : null;
              const price = selected ? selected.price : null;
              const compare_at_price = selected ? selected.compare_at_price : null;
              const featured_image = selected && selected.featured_image ? selected.featured_image.src : null;
              const available = selected ? selected.available : null;

              // 如果传入了列索引，则同步更新当前列的价格展示
              if (typeof columnIndex === 'number') {
                const prev = (this.variantsCurrent && this.variantsCurrent[columnIndex]) || {};
                this.$set(this.variantsCurrent, columnIndex, {
                  ...prev,
                  id: variantId,
                  price,
                  compare_at_price,
                  featured_image,
                  available,
                });
              }
            },
            // button 模式：拿到当前用于对比的选项值（option1/2/3），用于 label / swatch 匹配
            getVariantOptionValue(columnValue, item) {
              const pos = (this.variantPositionMap && this.variantPositionMap[columnValue]) || 1;
              const key = 'option' + String(pos);
              return (item && item[key]) || (item && item.public_title) || '';
            },
            // button 模式：按钮文本（优先显示当前 option 值，而不是 public_title 全标题）
            getVariantLabel(columnValue, item) {
              const value = this.getVariantOptionValue(columnValue, item);
              return value || (item && item.public_title) || '';
            },
            // button 模式：根据 color_swatch_config 匹配 CSS 变量串（如 "--swatch-background: #fff"）
            getColorSwatchStyle(columnValue, item) {
              const value = this.getVariantOptionValue(columnValue, item);
              const key = String(value || '')
                .toLowerCase()
                .trim();
              const map = (this.colorSwatchMap && this.colorSwatchMap[columnValue]) || {};
              return map[key] || '';
            },
            getVariantButtonStyle(columnValue, item) {
              const shouldOutputVariantMedia =
                this.outputVariantMediaMap && this.outputVariantMediaMap[columnValue] === true;
              const variantImage = item && item.featured_image && item.featured_image.src;

              if (shouldOutputVariantMedia && variantImage) {
                return `--swatch-background: url(${variantImage})`;
              }

              return this.getColorSwatchStyle(columnValue, item);
            },
            // 通用：从 options 构建 map 的工具方法，减少重复代码
            buildMapFromOptions(getValueFn) {
              const map = {};
              (this.options || []).forEach((opt) => {
                if (!opt || opt.value == null) return;
                const value = getValueFn(opt);
                if (value != null) {
                  map[opt.value] = value;
                }
              });
              return map;
            },
          },
          computed: {
            labelMap() {
              return this.buildMapFromOptions((opt) => opt.label);
            },
            imageMap() {
              return this.buildMapFromOptions((opt) => opt.data && opt.data.product_image);
            },
            variantsMap() {
              return this.buildMapFromOptions((opt) => opt.data && opt.data.variants);
            },
            variantPositionMap() {
              return this.buildMapFromOptions((opt) => opt.data && opt.data.variant_position);
            },
            outputVariantMediaMap() {
              return this.buildMapFromOptions((opt) => opt.data && opt.data.output_variant_media);
            },
            colorSwatchMap() {
              return this.buildMapFromOptions((opt) => {
                const arr =
                  opt && opt.data && Array.isArray(opt.data.color_swatch_config) ? opt.data.color_swatch_config : [];
                const m = {};
                arr.forEach((row) => {
                  if (!row || row.label == null) return;
                  const k = String(row.label).toLowerCase().trim();
                  const v = row.value;
                  if (k && v) m[k] = v;
                });
                return m;
              });
            },
            specificationImageMap() {
              return this.buildMapFromOptions((opt) => opt.data && opt.data.specification_image);
            },
            specificationListMap() {
              return this.buildMapFromOptions((opt) => opt.data && opt.data.specification_list);
            },
            minPriceMap() {
              return this.buildMapFromOptions((opt) => opt.min_price);
            },
            compareAtMinPriceMap() {
              return this.buildMapFromOptions((opt) => opt.compare_at_min_price);
            },
            productUrlMap() {
              return this.buildMapFromOptions((opt) => opt.product_url);
            },
          },
        });
      }
      initStyle() {
        const productDataEl = this.sectionsEl['product-data'];
        const learnMoreBtn = this.sectionsEl['learn-more'];
        if (!productDataEl && !learnMoreBtn) return;

        const productDataHeight = productDataEl.offsetHeight || productDataEl.getBoundingClientRect().height;

        productDataEl.style.setProperty('--yg-max-height', productDataHeight + 'px');
        if (productDataHeight > 600) {
          // 添加 clone 属性
          productDataEl.setAttribute('clone', '');
          productDataEl.style.setProperty('--yg-min-height', '500px');

          // 去除 yg-learn-more-button 的 hide 属性
          learnMoreBtn.classList.remove('hide');
        } else {
          productDataEl.removeAttribute('clone');
          learnMoreBtn.classList.add('hide');
        }
      }
      handleAddToCart(item) {
        const variantId = item?.dataset?.variantId || item?.getAttribute?.('data-variant-id');

        if (!variantId && !item.classList.contains('disabled')) return;

        const form = this.sectionsEl['product-form'];
        const idInput = this.sectionsEl['product-form-id'];
        if (!form || !idInput) return;

        // 写入变体 id
        idInput.value = String(variantId);
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        idInput.dispatchEvent(new Event('input', { bubbles: true }));

        // 触发表单提交事件（优先 requestSubmit，保证会触发 submit 监听/Ajax cart 逻辑）
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
          return;
        }

        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn && typeof submitBtn.click === 'function') {
          submitBtn.click();
          return;
        }

        // 最后兜底：dispatch submit（不保证一定真的提交），尽量满足“触发 submit 事件”诉求
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
      handleLearnMore(item) {
        const productDataEl = this.sectionsEl['product-data'];
        const isActive = item.classList.contains('active');
        const learnMoreTextEl = item.querySelector('.yg-learn-more-button-text');
        if (isActive) {
          // 当前为 active，需去除 active 和展示 clone
          item.classList.remove('active');
          productDataEl.setAttribute('clone', '');

          if (learnMoreTextEl) {
            // data-more-text 表示“Learn More”文本
            const moreText = learnMoreTextEl.getAttribute('data-more-text') || 'Learn More';
            learnMoreTextEl.textContent = moreText;
          }
        } else {
          // 当前非 active，添加 active，移除 clone
          item.classList.add('active');
          productDataEl.removeAttribute('clone');

          if (learnMoreTextEl) {
            // data-text 表示“Learn Less”文本
            const lessText = learnMoreTextEl.getAttribute('data-less-text') || 'Learn Less';
            learnMoreTextEl.textContent = lessText;
          }
        }
      }
    }

    if (!window.customElements.get('yg-product-compare')) {
      window.customElements.define('yg-product-compare', YGProductCompare);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-timeline-carousel"] && !Shopify.designMode) return;
  try {
    
  class YGTimelineCarousel extends HTMLElement {
    constructor() {
      super();
      this.mainSwiper = null;
      this.buttonSwiper = null;
      this.bindTimer = null;
      this.maskTimer = null;
      this.handleClick = this.handleClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleMainSlideChange = this.handleMainSlideChange.bind(this);
      this.handleButtonSwiperChange = this.handleButtonSwiperChange.bind(this);
    }

    get buttons() {
      return this.querySelectorAll('.yg-timeline-carousel__button');
    }

    get mainSwiperElement() {
      return this.querySelector('[data-timeline-main]');
    }

    get buttonSwiperElement() {
      return this.querySelector('[data-timeline-buttons]');
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      window.addEventListener('resize', this.handleResize);

      customElements.whenDefined('yg-swiper').then(() => {
        this.bindSwipers();
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('resize', this.handleResize);
      window.clearTimeout(this.bindTimer);
      window.clearTimeout(this.maskTimer);
      this.unbindSwipers();
    }

    bindSwipers(retryCount = 16) {
      const mainSwiper = this.mainSwiperElement?.swiper;
      const buttonSwiper = this.buttonSwiperElement?.swiper;

      if (!mainSwiper || !buttonSwiper) {
        if (retryCount > 0) {
          this.bindTimer = window.setTimeout(() => this.bindSwipers(retryCount - 1), 120);
        }

        return;
      }

      if (this.mainSwiper === mainSwiper && this.buttonSwiper === buttonSwiper) {
        return;
      }

      this.unbindSwipers();
      this.mainSwiper = mainSwiper;
      this.buttonSwiper = buttonSwiper;
      this.mainSwiper.on('activeIndexChange', this.handleMainSlideChange);
      this.mainSwiper.on('slideChange', this.handleMainSlideChange);
      this.buttonSwiper.on('activeIndexChange', this.handleButtonSwiperChange);
      this.buttonSwiper.on('slideChange', this.handleButtonSwiperChange);
      this.buttonSwiper.on('transitionEnd', this.handleButtonSwiperChange);
      this.buttonSwiper.on('setTranslate', this.handleButtonSwiperChange);
      this.buttonSwiper.on('update', this.handleButtonSwiperChange);
      this.updateActiveState(this.getActiveIndex());
      this.updateButtonMaskState();
    }

    unbindSwipers() {
      if (this.mainSwiper?.off) {
        this.mainSwiper.off('activeIndexChange', this.handleMainSlideChange);
        this.mainSwiper.off('slideChange', this.handleMainSlideChange);
      }

      if (this.buttonSwiper?.off) {
        this.buttonSwiper.off('activeIndexChange', this.handleButtonSwiperChange);
        this.buttonSwiper.off('slideChange', this.handleButtonSwiperChange);
        this.buttonSwiper.off('transitionEnd', this.handleButtonSwiperChange);
        this.buttonSwiper.off('setTranslate', this.handleButtonSwiperChange);
        this.buttonSwiper.off('update', this.handleButtonSwiperChange);
      }

      this.mainSwiper = null;
      this.buttonSwiper = null;
    }

    handleClick(event) {
      const button = event.target.closest('.yg-timeline-carousel__button');

      if (!button || !this.contains(button)) {
        return;
      }

      const index = Number(button.dataset.timelineIndex);

      if (Number.isNaN(index)) {
        return;
      }

      this.mainSwiper?.slideTo(index);
      this.updateActiveState(index);
    }

    handleResize() {
      this.mainSwiper?.update();
      this.buttonSwiper?.update();
      this.updateButtonMaskState();
    }

    handleMainSlideChange() {
      this.updateActiveState(this.getActiveIndex());
    }

    handleButtonSwiperChange() {
      this.updateButtonMaskState();
    }

    getActiveIndex() {
      if (!this.mainSwiper) {
        return 0;
      }

      return Number.isInteger(this.mainSwiper.activeIndex) ? this.mainSwiper.activeIndex : 0;
    }

    updateActiveState(activeIndex) {
      this.buttons.forEach((button, index) => {
        const isActive = index === activeIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      this.buttonSwiper?.slideTo(activeIndex);
      this.updateButtonMaskState();
      window.clearTimeout(this.maskTimer);
      this.maskTimer = window.setTimeout(() => {
        this.updateButtonMaskState();
      }, 320);
    }

    getButtonMaskValues() {
      if (!this.buttonSwiper) {
        return null;
      }

      const rawSnapGrid = Array.isArray(this.buttonSwiper.snapGrid) ? this.buttonSwiper.snapGrid : [];
      const firstSnap = rawSnapGrid[0] ?? 0;
      const lastSnap = rawSnapGrid[rawSnapGrid.length - 1] ?? firstSnap;
      const snapGrid = [Math.trunc(firstSnap), Math.trunc(lastSnap)];
      const translate = Number(Math.abs(this.buttonSwiper.translate || 0).toFixed(1));

      return {
        snapGrid,
        translate
      };
    }

    updateButtonMaskState() {
      const buttonSwiperElement = this.buttonSwiperElement;
      const maskValues = this.getButtonMaskValues();

      if (!buttonSwiperElement || !maskValues) {
        return;
      }

      const [firstSnap, lastSnap] = maskValues.snapGrid;
      const hasLeftMask = maskValues.translate > firstSnap;
      const hasRightMask = maskValues.translate < lastSnap;

      console.log(maskValues.translate,firstSnap,lastSnap,hasLeftMask);
      
      buttonSwiperElement.dataset.snapGrid = maskValues.snapGrid.join(',');
      buttonSwiperElement.dataset.translate = String(maskValues.translate);
      buttonSwiperElement.classList.toggle('has-left-mask', hasLeftMask);
      buttonSwiperElement.classList.toggle('has-right-mask', hasRightMask);
    }
  }

  if (!window.customElements.get('yg-timeline-carousel')) {
    window.customElements.define('yg-timeline-carousel', YGTimelineCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
